import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    marginLeft: '40px',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    height: '106px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #E0E0E0',
  },
  footer: {
    position: 'absolute',
    bottom: '32px',
    right: '50%',
    transform: 'translate(50%,-50%)',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    '@media (max-height: 768px)': {
      position: 'relative',
      bottom: 0,
      right: 0,
      transform: 'none',
      margin: '15px 0',
    },
  },
  container: {
    height: '100vh',
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
  },
  alertContainer: {
    display: 'flex',
    padding: '8px',
    minHeight: 'calc(100vh - 106px)',
    justifyContent: 'center',
  },
  alertboxes: {
    width: '500px',
    margin: '40px',
    display: 'flex',
    flexDirection: 'column',
    //  flex-direction:"column"
  },
  alertmessage: {
    display: 'flex',
    borderRadius: '4px',
    margin: '0 auto',
    width: '500px',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
  },
  alertbox: {
    display: 'flex',
    padding: '8px 18px',
  },
  alertIcon: {
    marginRight: '10px',
    color: '#F44336',
  },
  alertTitle: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
    color: '#621b16',
  },
}));
